<template>
    <section class="property-commute section-outline" v-if="haslatLng">
        <div class="commute-card p-y-2 p-x-2 bg-default">
            <div class="grid xs-grid-cols-1 gap-3">
                <div class="flex left middle">
                    <i class="title icon-car f2"></i>
                    <h2 class="f2 text-bold">{{ molang('dpp.propertyCommute.myCommuteTime') }}</h2>
                </div>
                <div class="f5 text-gray">{{ molang('dpp.propertyCommute.enterDistance') }}</div>
                <div class="flex add" v-show="currentViewStatus === 'add'">
                    <button type="button" @click="addNewAddress('search')" class="btn small secondary">
                        <i class="icon-plus"></i> Add Address
                    </button>
                </div>
                <div class="flex vertical" v-if="currentViewStatus === 'search'">
                    <mvtInputGeo ref="addressInput" class="normal" btnclass="" v-model="geoInfo"
                        placeholder="Address" />
                    <div class="commute-row flex center">
                        <div class="flex left vertical commute">
                            <i class="icon-car f3"></i> <span class="tag secondary f7">--min</span>
                        </div>
                        <div class="flex right vertical commute">
                            <i class="icon-walking f3"></i> <span class="tag secondary f7">--hr</span>
                        </div>
                        <div class="flex vertical commute">
                            <i class="icon-bicycle f3"></i> <span class="tag secondary f7">--min</span>
                        </div>
                    </div>
                </div>
                <div class="commute-row" v-for="(item, index) in fullCommuteArray" v-bind:key="index">
                    <span class="flex middle left m-b-2">
                        <div class="f6">
                            <b class="text-bold">{{ item.distance }} {{ getMilesTxt(item.distance) }}</b> from this property
                            to
                            <span>{{ item.name }}</span>
                        </div>
                    </span>
                    <div class="flex middle center">
                        <div class="flex left vertical commute">
                            <i class="icon-car f3"></i> <span class="tag secondary f7">{{ item.carCommute }}</span>
                        </div>
                        <div class="flex right vertical commute">
                            <i class="icon-walking f3"></i> <span class="tag secondary f7">{{ item.walkCommute }}</span>
                        </div>
                        <div class="flex vertical commute">
                            <i class="icon-bicycle f3"></i> <span
                                class="tag secondary f7">{{ item.bicycleCommute }}</span>
                        </div>
                    </div>
                </div>
                <button v-if="currentViewStatus === 'remove'" type="button" @click="removeCommute(index, 'add')"
                    class="btn small remove">
                    <div class="flex center middle">
                        <i class="icon icon-trash"></i><span class="f6"> Remove</span>
                    </div>
                </button>
            </div>
        </div>
    </section>
</template>
<script src="./property-commute.js"></script>

<style lang="scss">
@use "./property-commute.scss" as *;
</style>
